import React from "react";

/**
 * Small reusable chevron mark (›) mirroring the Twasal Awasal logo.
 * Used as an inline accent/divider throughout the site.
 */
export default function Chevron({ size = 24, color = "#981B37", className = "", strokeWidth = 3.2 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      data-testid="delfi-chevron-icon"
    >
      <path
        d="M8 4 L16 12 L8 20"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
